<template>
    <div>
        <sweet-modal blocking ref="createVendorPaymentEntry" class="modal" v-on:close="closeCreateVendorPaymentEntry">
            <el-form :model="form" size="mini" label-width="130px" ref="form" status-icon :rules="rules"  class="demo-ruleForm">
                <div style="display:flex; justify-content: center;">
                    <h2>Create Vendor Payment Entry</h2>
                </div>
                <!--{{purchaseOrder}}-->
                <el-row :span="24" :gutter="20">
                    <el-col :span="12">
                        <el-form-item prop="vendorId" :label="labelName">
                            <el-select disabled style="width:100%" no-data-text="no date" v-model="form.projectId" placeholder="Project">
                                <el-option
                                        v-for="item in projectList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                        @click.native="handleSelectProject(item)">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item v-if="form.taskId" prop="taskId" label="Task">
                            <el-select clearable :disabled="disabledInputs" style="width:100%" no-data-text="no date" v-model="form.taskId" placeholder="Task">
                                <el-option
                                        v-for="item in taskList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                        @click.native="handleSelectTask(item)">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :span="24" :gutter="20">
                    <el-col :span="12">
                        <el-form-item prop="vendorId" label="Payment To">
                            <el-select :disabled="disabledInputs" style="width:100%" no-data-text="no date" v-model="form.vendorId" placeholder="Payment To">
                                <el-option
                                        v-for="item in vendorList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                        @click.native="handleSelectVendor(item)">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item prop="date" label="Date Paid">
                            <el-date-picker
                                    v-model="form.date"
                                    format="d MMM yy"
                                    value-format="timestamp"
                                    type="date"
                                    placeholder="Pick a day">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :span="24" :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="From Bank Account" prop="fromBankAccountId">
                            <el-select style="width:100%" v-model="form.fromBankAccountId" placeholder="From Bank Account">
                                <el-option
                                        v-for="item in form.bankAccountList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Reference" prop="reference">
                            <el-input placeholder="Reference" v-model="form.reference"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :span="24" :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="Bank Charge" prop="dimensionId">
                            <el-input type="number" v-model="form.bankCharge"></el-input><span class="currency">USD</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Bank Balance">
                            {{formatPrice(form.bankBalance)}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :span="24">
                    <el-form-item label="Description" prop="description">
                        <el-input type="textarea" v-model="form.description"></el-input>
                    </el-form-item>
                </el-row>

                <!--TABLE START -->
                Allocated amounts in USD
                <el-table
                        size="mini"
                        border
                        :data="form.items"
                        style="width: 100%"
                        :cell-class-name="cellClassName"
                        @cell-click="cellClick">
                    <el-table-column
                            label="Transaction Type"
                            width="130">
                        <template slot-scope="scope">
                            {{scope.row.transactionType}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="No."
                            width="100">
                        <template slot-scope="scope">
                            {{scope.row.no}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Vendor Ref"
                            width="100">
                        <template slot-scope="scope">
                            {{scope.row.vendorRef}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Date"
                            width="100">
                        <template v-if="scope.row.date" slot-scope="scope">
                            {{moment(scope.row.date, 'X').format('DD MMM YYYY')}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Due Date"
                            width="100">
                        <template v-if="scope.row.dueDate" slot-scope="scope">
                            {{scope.row.dueDate}}
                            <!--{{moment(scope.row.dueDate, 'X').format('DD MMM YYYY')}}-->
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Amount"
                            width="100">
                        <template slot-scope="scope">
                            {{formatPrice(scope.row.amount)}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Other Allocations"
                            width="120">
                        <template slot-scope="scope">
                            {{formatPrice(scope.row.otherAllocations)}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Left to Allocate">
                        <template slot-scope="scope">
                            {{formatPrice(scope.row.leftToAllocate = countLeftToAllocate(scope.row.amount, scope.row.otherAllocations, scope.row.thisAllocation))}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="This Allocations">
                        <template slot-scope="scope">
                            <el-form-item label-width="0"
                                          :prop="'items.' + scope.$index + '.thisAllocation'"
                                          :rules="{
                                          required: true, message: 'Field is required', trigger: 'blur'
                                          }">
                                <money v-model="scope.row.thisAllocation" v-bind="money" @change.native="someHandler(scope.row)"></money>
                                <!--<el-input :disabled="disabledInputs" type="number" v-model="scope.row.allocations" size="mini"></el-input>-->
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Operations"
                            width="200">
                        <template slot-scope="scope">
                            <div>
                                <el-button
                                        size="mini"
                                        type="primary"
                                        plain
                                        @click="addAll(scope.$index, scope.row)">All</el-button>
                                <el-button
                                        size="mini"
                                        type="primary"
                                        plain
                                        @click="none(scope.$index, scope.row)">None</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <!--TABLE END -->

                <el-row :span="24">
                    <el-col :span="12" style="margin-top:20px;">
                        <el-form-item label="Amount of Discount">
                            <money v-model="form.discount" @change.native="changeDiscount(form.discount, form.items)" v-bind="money"></money>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :span="24" style="display:flex; justify-content: flex-end">
                    <el-col :span="12">
                        <div class="bill">
                            <h4><span>Total Amount</span><span>{{formatPrice(form.totalAmount = countTotalAmount(form.items, form.discount))}}</span></h4>
                            <el-divider></el-divider>
                        </div>
                    </el-col>
                </el-row>

                <el-form-item style="display: flex; justify-content: flex-end; margin-top:20px;">
                    <el-button @click="purchaseSubmit('form')" class="modal__btn" type="primary" plain size="medium">Create</el-button>
                </el-form-item>
            </el-form>
        </sweet-modal>

        <!--PURCHASE ORDER INFO MODAL-->
        <purchaseOrderInfoModal ref="purchaseOrderInfoModal"/>
        <!--PURCHASE ORDER INFO MODAL-->
    </div>
</template>

<script>
  let moment = require('moment')
  import axios from 'axios'
  import {Money} from 'v-money'
  import purchaseOrderInfoModal from '@/components/purchases/purchaseOrderInfoModal.vue'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue';


  export default {
    name: "vendorInvoiceModal",
    components:{
      SweetModal,
      purchaseOrderInfoModal,
      Money
    },
    props: ['selectedRow'],
    data() {
      return{
        money: {
          precision: 2,
          decimal: ',',
          thousands: '.'
        },
        activeState: 'project',
        action: 'create',
        disabledInputs: true,
        labelName: 'Project',
        projectList: [],
        taskList: [],
        vendorList:[],
        bankAccountList: [],
        purchaseOrder: {},
        itemsList:[],
        taxList: [],
        selectedTask: {},
        selectedVendor: {},
        selectedProject: {},
        moment:moment,
        form:{
          projectId: '',
          taskId: '',
          vendorId: '',
          date: null,
          fromBankAccountId: '',
          reference: null,
          bankCharge: '',
          bankBalance: '-3200',
          description: null,
          items:[],
          discount: '',
          totalAmount:'0'
        },
        rules:{
          vendorId: [
            { required: true, message: 'Please input Vendor name', trigger: 'blur' }
          ],
          reference: [
            { required: true, message: 'Please pick a reference', trigger: 'blur' }
          ],
          // itemsId:[
          //   { required: true, message: 'Please pick a reference', trigger: 'blur' }
          // ]
        },
      }
    },
    methods:{
      // // open modal purchases
      async openModalFromPurchses(state, purchaseOrder, projectId, taskId){
        try {
          this.purchaseOrder = purchaseOrder;
          this.form.projectId = projectId;
          this.form.taskId = taskId;
          this.form.vendorId = purchaseOrder.vendorId;
          this.vendorList.push(purchaseOrder.vendor);
          const urlParts = await this.buildUrl(state);

          this.labelName = urlParts.labelName;

          this.projectList = await this.getProjectList(urlParts.routeName);

          if(taskId){
            this.taskList = await this.getTaskList(projectId);
          }

          this.form.items = await this.buildTable(purchaseOrder);

          await this.$refs.createVendorPaymentEntry.open()
        }catch (err){
          console.log(err)
        }
      },
      getProjectList(routeName){
        return new Promise((resolve, reject) => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/${routeName}/list?companyId=${this.$route.query.companyId}`)
            .then(response => {
              resolve(response.data.list)
            }).catch(error =>{
            console.log(error)
            reject(error)
          })
        })
      },
      // async handleSelectProject(item){
      //   if(this.selectedProject.id !== item.id) {
      //     this.resetForm(true)
      //   }
      //   this.selectedProject = item
      //   let loader = this.$loading.show()
      //   console.log('selected project', item)
      //   const urlParts = this.buildUrl(this.activeState)
      //   // get task list
      //   this.taskList = await this.getTaskList(item.id)
      //   //get project directories
      //   await this.getDirectory(urlParts.stateProjectId, item.id)
      //
      //   this.disabledInputs = false
      //   loader.hide()
      // },
      // resetForm(isProj) {
      //   if(this.form.items.length !== 0){
      //     this.form.items = []
      //     // this.form.itemsId = []
      //     this.form.vendorId = ''
      //   }else if(!this.form.items.length) {
      //     this.form.vendorId = ''
      //   }
      //   if(isProj){
      //     this.form.taskId = ''
      //   }
      // },
      getDirectory(stateProjectId, id){
        return new Promise((resolve, reject) =>{
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .get(`/api/v1/vendorInvoice/directory?companyId=${this.$route.query.companyId}&${stateProjectId}=${id}`)
            .then(response => {
              this.vendorList = response.data.vendorList
              resolve(response.data)
              console.log(response.data)
            })
            .catch(error => {
              console.log('An error occurred:', error);
              reject(error)
            });
        })
      },
      getTaskList(projectId){
        const urlParts = this.buildUrl(this.activeState)
        return new Promise((resolve, reject) => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/${urlParts.stateProjectTasks}/list?companyId=${this.$route.query.companyId}&${urlParts.stateProjectId}=${projectId}`)
            .then(response => {
              console.log('response', response)
              resolve(response.data.list)
            })
            .catch(error => {
              console.log('An error occurred:', error);
              reject(error)
            });
        })
      },
      buildTable(purchaseOrder){
        const myPurchaseOrder = {
          id: purchaseOrder.id,
          transactionType: 'Purchase Order',
          type: 'purchaseOrder',
          no: purchaseOrder.code,
          vendorRef: purchaseOrder.reference,
          parentId: purchaseOrder.id,
          date: null,
          dueDate: purchaseOrder.orderDate,
          amount: purchaseOrder.totalAmount,
          otherAllocations: purchaseOrder.otherAllocation,
          leftToAllocate: purchaseOrder.leftToAllocate || null,
          thisAllocation: 0
        };
        return [myPurchaseOrder]
      },
      async handleSelectTask(item){
        if(this.selectedTask.id !== item.id) {
          this.resetForm(false)
        }
        this.selectedTask = item
        let loader = this.$loading.show()
        const urlParts = this.buildUrl(this.activeState)

        console.log('urlParts', urlParts)
        //get task directories
        await this.getDirectory(urlParts.stateTaskId, item.id)
        loader.hide()
      },
      handleSelectVendor(item){
        alert(item)
      },
      setItemToRequest(item){
        alert(item)
      },
      addItem(index, row){
        console.log(index, row)
      },
      removeItem(index, row){
        console.log(index, row)
      },
      removeTag(id){
        alert(id)
      },
      purchaseSubmit(form){
        this.$refs[form].validate((valid) => {
          if (valid) {
            const urlParts = this.buildUrl(this.activeState)

            const data = {
              projectId: this.form.projectId,
              taskId: this.form.taskId || null,
              vendorId: this.form.vendorId,
              date: this.form.date || null,
              fromBankAccountId: this.form.fromBankAccountId || null,
              reference: this.form.reference || null,
              bankCharge: this.form.bankCharge || null,
              bankBalance: this.form.bankBalance || null,
              description: this.form.description || null,
              items:[],
              discount: this.form.discount,
              totalAmount:this.form.totalAmount
            };

            const items = [];
            this.form.items.forEach(val => {
              if(val.thisAllocation){
                const item = {
                  transactionType: val.transactionType,
                  type: val.type,
                  code: val.no,
                  parentId: val.parentId,
                  vendorRef: val.vendorRefs,
                  date: val.date,
                  dueDate: val.dueDate,
                  amount: val.amount,
                  otherAllocations: val.otherAllocations,
                  leftToAllocate: val.leftToAllocate,
                  thisAllocation: val.thisAllocation
                };

                items.push(item)
              }
            });

            data.items = items;

            //check if items received
            if(!items.length){
              return this.$message({
                type: 'error',
                message: 'Select items'
              })
            }

            return new Promise((resolve, reject) =>{
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              axios
                .post(`/api/v1/paymentEntry/create?type=${this.activeState}&companyId=${this.$route.query.companyId}&${urlParts.stateProjectId}=${this.form.projectId}&${urlParts.stateTaskId}=${this.form.taskId ? this.form.taskId : null }`, data)
                .then(response => {
                  this.notification("Success", "Payment Entry Created", "success")
                  this.$emit('setValueProject', this.form.projectId);
                  this.$refs.createVendorPaymentEntry.close()
                })
                .catch(error => {
                  console.log('An error occurred:', error);
                  this.$refs.createVendorPaymentEntry.close()
                  reject(error)
                });
            })

          }
        })
      },
      closeCreateVendorPaymentEntry(){
        this.$refs['form'].resetFields();
        this.activeState = 'project',
          this.action = 'create',
          this.disabledInputs = true,
          this.labelName = 'Project',
          this.projectList = [],
          this.taskList = [],
          this.vendorList = [],
          this.bankAccountList = [],
          this.itemsList = [],
          this.taxList = [],
          this.selectedTask = {},
          this.selectedVendor = {},
          this.selectedProject = {},
          this.form.items = []
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
      cellClassName({row, column, rowIndex, columnIndex}){
        if(columnIndex === 1){
          return 'po-ve-number'
        }
      },
      cellClick(row, column, event){
        console.log('row', row)
        console.log('column', column)
        if(column.label === 'No.'){
          this.$refs.purchaseOrderInfoModal.openModalInfo(this.$route.query.companyId, this.form.projectId, this.form.taskId,  row.id, this.activeState, 'user');
        }
      },
      countLeftToAllocate(amount, otherAllocation, thisAllocation){
        console.log('amount', amount, 'otherAllocation', otherAllocation, 'thisAllocation', thisAllocation)
        return amount - (otherAllocation + thisAllocation)
      },
      someHandler(val){
        if(val.thisAllocation >= val.amount - val.otherAllocations){
          console.log('val.amount - val.leftToAllocate', val.amount - val.otherAllocations)
          console.log('val.thisAllocation', val.thisAllocation)
          val.thisAllocation = val.amount - val.otherAllocations
        }
        return val
      },
      addAll(index, row){
        row.thisAllocation = row.amount - row.otherAllocations
      },
      none(index, row){
        row.thisAllocation = 0
      },
      changeDiscount(discount, items){
        let sum = 0;
        if(items.length){
          items.forEach(val => {
            sum = sum + val.thisAllocation
          })
        }
        if(discount >= sum){
          this.form.discount = sum
        }
      },
      countTotalAmount(items, discount){
        console.log('items 111', items);
        let res = 0;
        if(items.length){
          items.forEach(val => {
            res = res + val.thisAllocation
          });
          res = res - discount
        }
        console.log('res', res)
        return res || 0
      },
      buildUrl(state) {
        let routeName = ''
        let labelName = ''
        let stateProjectId = ''
        let projectId = ''
        let stateTaskId = ''
        let taskId = ''
        let stateExpenseId = ''
        let stateProjectTasks = ''
        let stateTask = ''
        switch (state){
          case 'project':
            routeName = 'projects'
            labelName = 'Project'
            stateProjectId = 'projectId'
            stateProjectTasks = 'projectTasks'
            stateTaskId = 'projectTaskId'
            stateExpenseId = 'projectTaskVendorInvoiceId'
            stateTask = 'projectTask'
            break;
          case 'engagement':
            routeName = 'engagements'
            stateProjectId = 'engagementId'
            stateTaskId = 'engagementTaskId'
            stateProjectTasks = 'engagementTasks'
            stateExpenseId = 'engagementTaskVendorInvoiceId'
            labelName = 'Engagement'
            stateTask = 'engagementTask'
            break;
          case 'businessUnit':
            routeName = 'businessUnits'
            stateProjectId = 'businessUnitId'
            stateTaskId = 'businessUnitTaskId'
            stateProjectTasks = 'businessUnitTasks'
            stateExpenseId = 'businessUnitTaskVendorInvoiceId'
            labelName = 'Business Unit'
            stateTask = 'businessUnitTask'
            break;
        }
        return {
          state: state,
          routeName: routeName,
          stateProjectId: stateProjectId,
          labelName: labelName,
          projectId: projectId,
          stateTaskId: stateTaskId,
          stateProjectTasks: stateProjectTasks,
          taskId: taskId,
          stateExpenseId: stateExpenseId,
          stateTask: stateTask }
      }
    }
  }
</script>

<style lang="less" scoped>
    /deep/.el-date-editor.el-input, .el-date-editor.el-input__inner {
        width:100%;
    }
    /deep/.sweet-modal-overlay{
        z-index:1000;
        .sweet-modal {
            max-width: 100% !important;
        }
    }
    /deep/.el-form-item__content{
        display:flex;
        .currency{
            margin-left: 10px;
            width:40px;
        }
    }
    .bill{
        text-align:right;
        h4{
            line-height:0.6;
            span{
                padding: 0 10px;
            }
        }
        .payment-to-vendor{
            background: rgb(227, 228, 230);
            h3{
                span{
                    padding: 0 10px;
                }
            }
        }
    }
    /deep/.v-money{
        height: 28px;
        line-height: 28px;
        -webkit-appearance: none;
        background-color: #FFF;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        font-size: inherit;
        outline: 0;
        padding: 0 15px;
        -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
        transition: border-color .2s cubic-bezier(.645,.045,.355,1);
        width: 100%;
    }
    /deep/.po-ve-number{
        cursor:pointer;
    }
</style>
